import(/* webpackMode: "eager" */ "/home/turbooghost/Coding/cpl-webiste/src/app/apply-now/page.tsx");
